import React from 'react';
import { useProjectVersionActions } from '../../../../resource/resources/artifacts/project/projectVersionResource';
import { PropertyValidation } from '../../../../resource/services/outlineTypes';
import { Controlled_AutocompleteReferenceTextField } from './Controlled_AutocompleteReferenceTextField';

export const Controlled_ProjectVersionTextField = ({
    id,
    projectId,
    projectVersionIdToFilterOut,
    onChange,
    readOnly,
    label,
    propertyValidation,
}: {
    id: string | null;
    projectVersionIdToFilterOut?: string;
    projectId: string | undefined | null;
    onChange?: (id: string | null) => void;
    readOnly: boolean;
    label?: string;
    propertyValidation: PropertyValidation | null | undefined;
}) => {
    const projectVersionActions = useProjectVersionActions();
    const projectVersionsQuery = projectVersionActions.useGetAllResources(projectId);

    return (
        <Controlled_AutocompleteReferenceTextField
            idSelector={'id'}
            idValue={id}
            readOnly={readOnly}
            onChange={onChange}
            propertyValidation={propertyValidation}
            propertyDetails={undefined}
            query={projectVersionsQuery}
            filterResources={(resources) => resources.filter((resource) => resource.id !== projectVersionIdToFilterOut)}
            getOptionLabel={(option) => option.versionInfo.versionNumber}
            label={label}
            sortOptionsBy={(a, b) => a.persistableInfo.createdAt.localeCompare(b.persistableInfo.createdAt)}
        />
    );
};
